import $ from 'jquery';
import BaseModel from '@bingads-webui-campaign-legacy/bulk-operation/util/bulk-edit-job';
import bidTypes from '@bingads-webui-component-legacy/schema/bid/bidType';

export default class Model extends BaseModel {

  get defaults() {
    return $.extend(
      {},
      BaseModel.defaults, {
        Id: null,
        Entity: 'Campaign',
        BatchAction: {
          Actions: [{
            '@odata.type': '#Model.AudienceAssociationAction',
            'BidType': bidTypes.BidOnly,
            'AssociationList': [],
            'ExclusionList': [],
            'Property': 'AudienceAssociation',
          }],
        },
      });
  }
}
